import React, { useEffect, useState } from 'react';
import SubPage from '../SubPage';
import Cards from './Cards';
import D from './solData';
import { useLang } from '../../LanguageContext';

const CRUMB = { ko: 'ML-CARE 솔루션', en: 'ML-CARE Solution' };
const T = {
  title: { ko: '작동 구조', en: 'How It Works' },
  lede:  { ko: '감지부터 교체까지, ML-CARE 솔루션이 작동하는 과정입니다.',
           en: 'From detection to change — how the solution works, step by step.' },
  h2:    { ko: '감지 → 분석 → 알림 → 교체', en: 'Detect → Analyze → Alert → Change' },
};

const STEPS = [
  { h: { ko: '감지', en: 'Detect' },
    p: { ko: '기저귀에 부착된 BLE 센서가 배뇨·배변 상태를 24시간 실시간 감지합니다',
         en: 'A BLE sensor on the diaper detects urination and bowel movements around the clock.' } },
  { h: { ko: '분석', en: 'Analyze' },
    p: { ko: '센서 신호를 중계기가 수신해 서버로 보내면 관리 시스템이 분석하여 상태를 판별합니다',
         en: 'The repeater forwards the signal to the server, where the system analyzes and classifies the state.' } },
  { h: { ko: '알림', en: 'Alert' },
    p: { ko: '교체가 필요한 시점에 간병인에게 즉시 알림을 전달합니다',
         en: 'The moment a change is needed, the caregiver is notified immediately.' } },
  { h: { ko: '교체', en: 'Change' },
    p: { ko: '정확한 시점의 교체로 욕창·피부염을 예방하고 기록이 데이터로 축적됩니다',
         en: 'Changing at the right moment prevents bedsores and dermatitis, and every record accumulates as data.' } },
];

function SolStructure() {
  const { lang } = useLang();
  const [total, setTotal] = useState(null);

  useEffect(() => {
    let alive = true;
    fetch('/api/stats').then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (alive && d && typeof d.total === 'number') setTotal(d.total); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  // 시안 본문에 '43만 건'이 박혀 있다 — 지표 바와 어긋나지 않게 실값으로 바꿔 끼운다.
  // 값을 못 받으면 원문을 그대로 둔다(틀린 숫자를 새로 만들지 않는다).
  const patch = (h, p, lg) => {
    if (!p || total === null) return p;
    const man = Math.floor(total / 10000);
    return lg === 'ko'
      ? p.replace(/\d+만 건/, `${man}만 건`)
      : p.replace(/[\d,]+(?= detection records)/, total.toLocaleString('en-US'));
  };

  return (
    <SubPage crumb={CRUMB[lang]} title={T.title[lang]} lede={T.lede[lang]}>
      <div className="sp-label">HOW IT WORKS</div>
      <h2>{T.h2[lang]}</h2>
      <div className="sp-flow sp-mt">
        {STEPS.map((s, i) => (
          <React.Fragment key={i}>
            <div className="sp-step">
              <div className="n">{i + 1}</div>
              <h3>{s.h[lang]}</h3>
              <p>{s.p[lang]}</p>
            </div>
            {i < STEPS.length - 1 && <div className="sp-arrow" aria-hidden="true">→</div>}
          </React.Fragment>
        ))}
      </div>
      <Cards items={D.structure[0]} cols={2} className="sp-mt-lg" patch={patch} />
    </SubPage>
  );
}

export default SolStructure;
